import React  from 'react';
import logo from '../../../assets/icons/logo.png';
import { ReactComponent as NTIcon } from "../../../assets/icons/nt-logo.svg";
import {useSelector} from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

const ErrorPage = () => {
  const error = useSelector(state => state.auth.error);
  const loading = useSelector(state => state.auth.loading);
  const { t } = useTranslation();

  return (
    <div className="auth-card">
      <div className="auth-card-head">
        <img src={logo} alt="logo" />
      </div>
      <form className="auth-card-form">
        {loading && <CircularProgress color="inherit" />}
        {error && <span className='auth-failed'>{error}</span>}
        <Link to='/auth/login'>{t('Sign In Page')}</Link>

        <div className='loginO365-image'>
          <NTIcon />
        </div>
      </form>
    </div>
  )
}

export default ErrorPage;